/* tslint:disable */
require('./IFrameDialogContent.module.css');
const styles = {
  iFrameDialog: 'iFrameDialog_5fc5b6ba',
};

export default styles;
/* tslint:enable */